export default {
  filters: {
    today: 'Oggi',
    yesterday: 'Ieri',
    this_week: 'Questa settimana',
    last_week: 'Settimana scorsa',
    this_month: 'Questo mese',
    last_month: 'Mese scorso',
    all: 'Tutti',
  },
};
